import { render, staticRenderFns } from "./PaymentHistoriesView.vue?vue&type=template&id=6454cc03&"
import script from "./PaymentHistoriesView.vue?vue&type=script&lang=js&"
export * from "./PaymentHistoriesView.vue?vue&type=script&lang=js&"
import style0 from "./PaymentHistoriesView.vue?vue&type=style&index=0&id=6454cc03&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports